/** 调度后台侧栏菜单定义（与 sys_menu.path 一致，用于无权限数据时的兜底） */
export const DISPATCH_SIDEBAR_MENUS = [
  { id: "dispatch-console", name: "调度控制台", path: "/dispatch/console", icon: "dashboard", sort_no: 1 },
  { id: "dispatch-orders", name: "待指派订单池", path: "/dispatch/orders", icon: "unordered-list", sort_no: 2 },
  { id: "dispatch-caregivers", name: "护工档案", path: "/dispatch/caregivers", icon: "idcard", sort_no: 3 },
  { id: "dispatch-hospitals", name: "医院配置", path: "/dispatch/hospitals", icon: "bank", sort_no: 4 },
  { id: "dispatch-family-users", name: "用户管理", path: "/dispatch/family-users", icon: "team", sort_no: 5 },
  { id: "dispatch-accounts", name: "账号管理", path: "/dispatch/accounts", icon: "safety", sort_no: 6 },
];

export function isDispatchMenuPath(path) {
  return typeof path === "string" && path.indexOf("/dispatch/") === 0;
}

export function collectDispatchMenusFromUser(user) {
  if (!user || !user.roles || !user.roles.length) return [];
  const map = new Map();
  user.roles.forEach((role) => {
    (role.menus || []).forEach((menu) => {
      if (menu && isDispatchMenuPath(menu.path)) {
        map.set(menu.id, {
          id: menu.id,
          name: menu.name,
          path: menu.path,
          icon: menu.icon || "setting",
          sort_no: menu.sort_no != null ? menu.sort_no : 0,
        });
      }
    });
  });
  return Array.from(map.values()).sort((a, b) => (a.sort_no || 0) - (b.sort_no || 0));
}

export function resolveDispatchSidebarMenus(user, fallbackAll = false) {
  const fromRoles = collectDispatchMenusFromUser(user);
  if (fromRoles.length) return fromRoles;
  if (fallbackAll && user && Number(user.superAdmin) === 1) {
    return DISPATCH_SIDEBAR_MENUS.map((m) => ({ ...m }));
  }
  return [];
}
